import AuthFormContainer from '@/features/auth/signup/components/AuthFormContainer';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { useAuth } from '@/contexts/AuthContext';
import { verificationFailedRoute } from '@/features/auth/signup/routes/verificationFailedRoute.ts';
import { useNavigate } from '@tanstack/react-router';

const getErrorMessage = (reason?: string): string => {
  switch (reason) {
    case 'invalid':
      return 'Link weryfikacyjny jest nieprawidłowy lub wygasł.';
    case 'expired':
      return 'Link weryfikacyjny wygasł. Wyślij nowy link poniżej.';
    default:
      return 'Weryfikacja adresu email nie powiodła się.';
  }
};

export const VerificationFailedPage = () => {
  const { reason } = verificationFailedRoute.useSearch();
  const { user } = useAuth();
  const navigate = useNavigate();

  // Wysyłka dzieje się na stronie weryfikacji przy wejściu — stąd tylko tam kierujemy.
  const handleResend = () => navigate({ to: '/auth/email-verification' });

  return (
    <AuthFormContainer title="Weryfikacja nie powiodła się">
      <div className="flex w-full flex-col items-start gap-8">
        <p className="mt-4 w-full text-center text-[#6C6C93]">
          {getErrorMessage(reason)}
        </p>

        <div className="flex w-full flex-col gap-4">
          {user && (
            <ActionButton
              type="button"
              tone="accent"
              size="block"
              onClick={handleResend}
            >
              Wyślij link ponownie
            </ActionButton>
          )}

          <ActionButton
            type="button"
            tone="outline"
            size="block"
            onClick={() => navigate({ to: '/auth/login' })}
          >
            Wróć do logowania
          </ActionButton>
        </div>
      </div>
    </AuthFormContainer>
  );
};
